'use strict';

/*global services*/
/*global getPosition*/
/*global isEmpty*/
/*global blockElement*/
/*global unBlockElement*/
/*global setDBCookie*/

function PageIntro(scenariosContainerId) {
    this.scenariosContainerId = scenariosContainerId;
    this.$scenarios = null;

    //----------------------------------------------
    this.actualScenarioID = null;
    this.$actualScenario = null;
    this.actualScenarioStep = null;
    this.actualScenarioStepElem = null;

    //----------------------------------------------
    this.$scenarioPicker = null;
    this.scenarioPickerZIndex = 98;
    
    //----------------------------------------------
    this.$stepHighlighter = null;
    this.stepHighlighterZIndex = 99;
    this.stepHighlighterPadding = 3;
    this.stepHighlighterPosition = { x: 0, y: 0, x2: 0, y2: 0 };

    //----------------------------------------------
    this.$stepHighlighterToolTip = null;
    this.cancelTitle = 'Quit';
    this.prevStepTitle = 'Back';
    this.nextStepTitle = 'Next';
    this.stepHighlighterToolTipWidth = 250;            

    this.$stepHighlighterWizard = null;

    //----------------------------------------------
    this.highlightBtnIntervalTimeout = null;
    this.autoCancelTimeout = null;

    //----------------------------------------------
    this.pageDoc = null;

    //------------------------------------------------------------------

    this.init();
}

PageIntro.prototype = $.extend({}, {
    construtor: 'PageIntro', 

    regCallBacks: function regCallBacks() {
        var _this = this;

        $('body').on('click', '.run-intro', function runIntroClb() {
            _this.runIntro($(this));
            return false;
        });

        $('body').on('click', '.cancel-intro', function cancelIntroClb() {
            _this.cancelIntro();
            return false;
        });

        $('body').on('click', '.step-highlighter-tooltip .tooltip-buttons .next-step', function nextStepClb() {
            _this.nextStepIntro();
            return false;
        });

        $('body').on('click', '.step-highlighter-tooltip .tooltip-buttons .prev-step', function nextStepClb() {
            _this.prevStepIntro();
            return false;
        });

        $('body').on('click', '.step-highlighter-tooltip .tooltip-cancel-button .cancel', function nextStepClb() {
            _this.cancelIntro();
            return false;
        });

        $('body').on('click', '.step-highlighter-tooltip .tooltip-progress-bar .go-to-step', function goToStepClb() {
            return false;
        });

        /*$('body').on('click', '.viewScenarios', function viewScenariosClb() {
            _this.viewScenarios($(this));
            return false;
        });*/  

        $('body').on('keydown', function keyDownClb(e) {
            if (_this.$stepHighlighter.find('input:focus').length === 0) {                    
                if (_this.$actualScenario && _this.$stepHighlighter.is(':visible')) {
                    switch (e.keyCode) {
                        case 39 : {
                            _this.nextStepIntro(); 
                            return false;
                        } break;
                        case 37 : {
                            _this.prevStepIntro(); 
                            return false;
                        } break;
                        case 27 : {
                            _this.cancelIntro(); 
                            return false;
                        } break;
                    }
                }
            }
        });

        $('body').on('mousemove', function mouseMoveClb(e) {
            var mouseShow = null;
            var mouseHide = null;

            if (e.pageX >= _this.stepHighlighterPosition.x1 && e.pageX <= _this.stepHighlighterPosition.x2 && e.pageY >= _this.stepHighlighterPosition.y1 && e.pageY <= _this.stepHighlighterPosition.y2) {
               if (_this.$actualScenario && _this.$stepHighlighter.hasClass('auto-hide')) {
                    var zIndex = !isEmpty(_this.actualScenarioStepElem.data('z_index')) ? _this.actualScenarioStepElem.data('z_index') : _this.stepHighlighterZIndex;

                    _this.$stepHighlighter.hide();
                    _this.$stepHighlighterWizard.css({ 'z-index': zIndex });
                    _this.$stepHighlighterWizard.show();
                    mouseHide = _this.actualScenarioStepElem.data('mouse_hide');
                    if (!isEmpty(mouseHide)) {
                        window[mouseHide]();
                    }
               }
            } else {
               if (_this.$actualScenario && _this.$stepHighlighter.hasClass('auto-hide')) {
                    _this.$stepHighlighter.show();
                    _this.$stepHighlighterWizard.hide();
                    mouseShow = _this.actualScenarioStepElem.data('mouse_show');
                    if(!isEmpty(mouseShow)) {
                        window[mouseShow]();
                    }
               }

               if (_this.actualScenarioStepElem) {
                    var hideIfMouseOver = _this.actualScenarioStepElem.data('hide_if_mouse_over');
                    if (!isEmpty(hideIfMouseOver)) {
                        var $parent = $(e.target).closest(hideIfMouseOver);
                        var $elem  = $(hideIfMouseOver);
                        if ($parent.is($elem) || $(e.target).is($elem)) {
                            _this.$stepHighlighter.hide();
                            _this.$stepHighlighterWizard.show();
                            mouseHide = _this.actualScenarioStepElem.data('mouse_hide');
                            if (!isEmpty(mouseHide)) {
                                window[mouseHide]();
                            }
                        } else {
                            _this.$stepHighlighter.show();
                            _this.$stepHighlighterWizard.hide();
                            mouseShow = _this.actualScenarioStepElem.data('mouse_show');
                            if (!isEmpty(mouseShow)) {
                                window[mouseShow]();
                            }
                        }  
                    }
                }
            }                    
        });

        $('body').on('click', function hideScenarioPickerClb() {
            _this.hideScenarioPicker();
        });

        $(window).on('resize', function recountHighlighterClb() {
            if(_this.$actualScenario) {
                _this.viewScenarioStep(_this.$actualScenario, _this.actualScenarioStep);
            }
        });

    },

    //------------------------------------------------------------------

    viewScenarios: function viewScenarios(btn) {
        var _this = this;

        var scenariosIDs = btn.data('scenarios').split(';');

        if(scenariosIDs.length) {
            _this.hideStepHighlighter();

            _this.clearScenarioPicker();
            $.each(scenariosIDs, function (index, scenarioID) {
                _this.addScenarioIntoPicker(scenarioID);
            });

            _this.viewScenarioPicker(btn.offset().left, btn.offset().top + btn.outerHeight());
        }
    },

    runIntro: function runIntro(btn) {
        var _this = this;

        if (_this.$actualScenario) {
            if (_this.$stepHighlighter.is(':animated')) {
                _this.$stepHighlighter.finish();
            }

            _this.cancelIntro();
            setTimeout(function () {
                _this.runIntro(btn);
            }, 500);                    
        } else {
            var scenario = _this.$scenarios.find('#' + btn.data('scenario'));                

            if (scenario.length) {                
                var action  = scenario.data('action');
                if (!isEmpty(action)) {
                    if (!window[action]()) {
                        setTimeout(function () {
                            _this.runIntro(btn);
                        }, 1000);
                        return;
                    }
                }

                _this.actualScenarioID = btn.data('scenario');                
                _this.$actualScenario = _this.$scenarios.find('#' + _this.actualScenarioID);                
                _this.actualScenarioStep = null;
                _this.actualScenarioStepElem = null;

                var nextStep = btn.data('step');
                if(isEmpty(nextStep)) {
                    nextStep = _this.getNextScenarioStep(_this.$actualScenario);
                }
                if (!isEmpty(nextStep)) {
                    var state = _this.viewScenarioStep(_this.$actualScenario, nextStep);
                    if (state > 0) {
                        _this.actualScenarioStep = nextStep;
                        if (!_this.$actualScenario.data('without_doc')) {
                            _this.openPageDoc();
                        }

                        $('body').addClass('run-page-intro');
                    } else {
                        _this.cancelIntro();
                    }
                } else {
                    _this.cancelIntro();
                }
            } else {
                _this.loadScenario(btn.data('scenario'), function () {
                    _this.runIntro(btn);
                }, btn.data('scenario_data'));
            }
        }
    },

    loadScenario: function loadScenario(scenarioID, callBack, data) {
        var _this = this;

        var $btn = $('body .header .wizards');
        blockElement($btn);
        $.postCORS(services.get('configurations').param('DomainURL') + '/?action=documentation&method=js_load_page_intro_scenario&scenario_id=' + scenarioID, data, function loadScenarioClb(res) {
            unBlockElement($btn);
            try {
                res = JSON.parse(res);
                if (res.msg === 'SUCCESS') {
                    _this.$scenarios.find('#' + scenarioID).remove();
                    _this.$scenarios.append(res.data.html);

                    if (_this.$scenarios.find('#' + scenarioID).length && callBack) {
                        callBack();
                    }
                } else {
                    services.get('development').viewSiteErrorMsg(res);
                }
            } catch(e) {
                services.get('development').viewSiteErrorMsg(res, e);
            }
        });
    },

    nextStepIntro: function nextStepIntro() {
        var _this = this;

        if (_this.$actualScenario) {
            if (!_this.isLastScenarioStep(_this.$actualScenario, _this.actualScenarioStep)) {                        
                var nextStep = _this.getNextScenarioStep(_this.$actualScenario, _this.actualScenarioStep);                    
                if (!isEmpty(_this.actualScenarioStep)) {
                    var state = _this.viewScenarioStep(_this.$actualScenario, nextStep);
                    if (state) {
                        _this.actualScenarioStep = nextStep;                                
                        if (state < 0) {
                            _this.nextStepIntro();    
                        }
                    }
                }
            } else if (_this.$actualScenario.data('next_scenario')) {
                var nextScenario = _this.$actualScenario.data('next_scenario');
                _this.cancelIntro();  
                setTimeout(function () {
                    _this.autoStartIntro(nextScenario);    
                }, 1000);                        
            }
        }
    },

    prevStepIntro: function prevStepIntro() {
        var _this = this;

        if (_this.$actualScenario) {
            if (!_this.isFirstScenarioStep(_this.$actualScenario, _this.actualScenarioStep)) {
                _this.actualScenarioStep = _this.getPrevScenarioStep(_this.$actualScenario, _this.actualScenarioStep);                    
                if (!isEmpty(_this.actualScenarioStep)) {
                    _this.viewScenarioStep(_this.$actualScenario, _this.actualScenarioStep);
                }
            } else if (_this.$actualScenario.data('prev_scenario')) {
                var prevScenario = _this.$actualScenario.data('prev_scenario');
                var prevScenarioStep = _this.$scenarios.find('#' + _this.$actualScenario.data('prev_scenario')).find('.step:last').data('step');
                _this.cancelIntro();
                setTimeout(function () {
                    _this.autoStartIntro(prevScenario, prevScenarioStep);
                }, 1000);
            }
        }
    },

    goToStepIntro: function goToStepIntro(step) {
        var _this = this;

        if (_this.$actualScenario && step > 1) {
            if (!_this.isLastScenarioStep(_this.$actualScenario, _this.actualScenarioStep)) {                        
                var nextStep = _this.getNextScenarioStep(_this.$actualScenario, step - 1);                    
                if (!isEmpty(_this.actualScenarioStep)) {
                    var state = _this.viewScenarioStep(_this.$actualScenario, nextStep);
                    if (state) {
                        _this.actualScenarioStep = nextStep;                                
                        if (state < 0) {
                            _this.nextStepIntro();    
                        }
                    }
                }
            } else if (_this.$actualScenario.data('next_scenario')) {
                var nextScenario = _this.$actualScenario.data('next_scenario');
                _this.cancelIntro();  
                setTimeout(function () {
                    _this.autoStartIntro(nextScenario);    
                }, 1000);                        
            }
        }
    },

    actualStepIntro: function actualStepIntro() {
        var _this = this;

        if (_this.$actualScenario) {
            if (!isEmpty(_this.actualScenarioStep)) {
                var state = _this.viewScenarioStep(_this.$actualScenario, _this.actualScenarioStep);
                if (state) {
                    if (state < 0) {
                        _this.nextStepIntro();    
                    }
                }
            }
        }
    },

    cancelIntro: function cancelIntro() {
        var _this = this;

        clearTimeout(_this.autoCancelTimeout);

        if (_this.$actualScenario) {
            _this.hideStepHighlighter();

            if (_this.$actualScenario.data('is_dynamic')) {
                _this.$scenarios.find('#' + _this.actualScenarioID).remove();
            }

            _this.actualScenarioID = null;
            _this.$actualScenario = null;
            _this.actualScenarioStep = null;
            _this.actualScenarioStepElem = null;

            _this.$stepHighlighterWizard.hide();
        }
    },

    setAutoCancelIntro: function setAutoCancelIntro(timeout, callBack) {
        var _this = this;

        _this.autoCancelTimeout = setTimeout(function () {
            _this.cancelIntro();
            if (callBack) {
                callBack();
            }
        }, timeout);
    },

    isRunningScenario: function isRunningScenario() {
        var _this = this;

        if (_this.$actualScenario) {
            return true;
        }
        return false;
    },

    //------------------------------------------------------------------

    getNextScenarioStep: function getNextScenarioStep($scenario, actStep) {
        var _this = this;

        var nextStep         = null;
        var $nextScenarioStep = null;

        if (isEmpty(actStep)) {
            $nextScenarioStep = $scenario.find('.step:first');
        } else {
            $nextScenarioStep = $scenario.find('.step[data-step="' + actStep + '"]').next('.step');
        }

        if ($nextScenarioStep.length) {
            nextStep = $nextScenarioStep.data('step');
        }

        return nextStep;
    },

    getPrevScenarioStep: function getPrevScenarioStep($scenario, actStep) {
        var _this = this;

        var prevStep = null;
        var $prevScenarioStep = null;

        if (isEmpty(actStep)) {
            $prevScenarioStep = $scenario.find('.step:first');
        } else {
            $prevScenarioStep = $scenario.find('.step[data-step="' + actStep + '"]').prev('.step');
        }

        if ($prevScenarioStep.length) {
            prevStep = $prevScenarioStep.data('step');
        }

        return prevStep;
    },

    getScenarioStep: function getScenarioStep($scenario, step) {
        var _this = this;

        return $scenario.find('.step[data-step="' + step + '"]');
    },

    isLastScenarioStep: function isLastScenarioStep($scenario, step) {
        var _this = this;

        return !_this.getNextScenarioStep($scenario, step) ? true : false;
    },

    isFirstScenarioStep: function isFirstScenarioStep($scenario, step) {
        var _this = this;

        return !_this.getPrevScenarioStep($scenario, step) ? true : false;
    },

    getScenarioSteps: function getScenarioSteps($scenario) {
        var _this = this;

        return $scenario.find('.step');
    },

    viewScenarioStep: function viewScenarioStep($scenario, step, back) {
        var _this = this;

        var $scenarioStep = $scenario.find('.step[data-step="' + step + '"]');

        //provedeme pre akci
        var preAction  = $scenarioStep.data('pre_action');
        if(!isEmpty(preAction)) {
            window[preAction]();
        }

        var $elem = $($scenarioStep.data('selector')); 
        if ($elem.length === 0 && $scenarioStep.data('alt_selector')) {                    
            var $altElem = $($scenarioStep.data('alt_selector')); 
            if ($altElem.length === 1) {
                $elem = $altElem;
            }
        }
        
        if ($elem.length === 1) {
            var condition  = $scenarioStep.data('condition');
            if (!isEmpty(condition)) {
                if (!window[condition]($elem)) {
                    if ($scenarioStep.data('skipable')) {
                        return -1;
                    }

                    return 0;
                }
            } 

            _this.scrollElemToViewScreen($elem, function () {
                //zobrazime highlighter nad elementem
                var autoHide = $scenarioStep.data('auto_hide') ? true : false;
                _this.$stepHighlighterToolTip.hide();
                _this.showStepHighlighterOverElem($elem, autoHide, true, function () {
                    //zobrazime tooltip
                    var preferPosition = $scenarioStep.data('position');
                    _this.updateStepHighlighterToolTip($scenario, step, $elem, preferPosition);

                    //provedeme akci
                    var postAction  = $scenarioStep.data('post_action');
                    if (!isEmpty(postAction)) {
                        window[postAction]($elem);
                    }
                });                       

                //provedeme akci
                var action  = $scenarioStep.data('action');
                if (!isEmpty(action)) {
                    window[action]($elem);
                }

                //provedem highlight v dokumentaci
                var anchor = $scenarioStep.data('anchor');
                if (!isEmpty(anchor) && anchor) {
                    _this.highlightPageDoc(anchor);
                } else {
                    _this.highlightPageDoc();
                } 

                _this.actualScenarioStepElem = $scenarioStep;
            });

            return 1;
        }

        if ($scenarioStep.data('skipable')) {
            return -1;
        }

        return 0;
    },

    //------------------------------------------------------------------

    removeNextButtonHightlight: function removeNextButtonHightlight() {
        var _this = this;

        clearInterval(_this.highlightBtnIntervalTimeout);
        _this.$stepHighlighterToolTip.find('.tooltip-cancel-button').removeClass('highlight');    
    },

    addNextButtonHightlight: function addNextButtonHightlight() {
        var _this = this;

        _this.highlightBtnIntervalTimeout = setInterval(function () {
            _this.$stepHighlighterToolTip.find('.next-step').addClass('highlight');
            setTimeout(function () {
                _this.$stepHighlighterToolTip.find('.next-step').removeClass('highlight');    
            }, 750);
        }, 1500);
    },

    //------------------------------------------------------------------

    buildStepHighlighter: function buildStepHighlighter() {
        var _this = this;

        _this.$stepHighlighter = $('<div id="' + _this.scenariosContainerId + '-step-highlighter" class="step-highlighter-wrapper">');
        _this.$stepHighlighter.append($('<div class="step-highlighter">'));
        _this.$stepHighlighter.css({ 'z-index': _this.stepHighlighterZIndex });

        $('body').append(_this.$stepHighlighter);                
        _this.buildStepHighlighterToolTip();
        _this.buildStepHighlighterWizard();
    },

    buildStepHighlighterToolTip: function buildStepHighlighterToolTip() {
        var _this = this;

        var $progressBar = $('<div class=tooltip-progress-bar>');

        var $counter = $('<div class=tooltip-counter>');
        $counter.append($('<span class="act-step-number">').html(0));
        $counter.append($('<span class="sep">').html('/'));
        $counter.append($('<span class="total-step-number">').html(0));

        var $buttons = $('<div class=tooltip-buttons>');
        $buttons.append($('<a href="#" class="button prev-step">').html('<i class="fa fa-long-arrow-left"></i> ' + _this.prevStepTitle));
        $buttons.append($('<a href="#" class="button next-step">').html(_this.nextStepTitle + ' <i class="fa fa-long-arrow-right"></i>'));

        var $cancelButton = $('<div class=tooltip-cancel-button>');
        $cancelButton.append($('<a href="#" class="button cancel" title="' + _this.cancelTitle + '">').append($('<i class="fa fa-times-circle">')));

        var $tooltip = $('<div class="step-highlighter-tooltip">');
        $tooltip.append($('<div class="tooltip-header"></div>'));
        $tooltip.append($('<div class="tooltip-title"></div>'));
        $tooltip.append($('<div class="tooltip-desc"></div>'));
        $tooltip.append($('<div class=tooltip-progress-bar-wrapper>').append($progressBar));
        $tooltip.append($('<div class=tooltip-counter-wrapper>').append($counter));
        $tooltip.append($('<div class=tooltip-cancel-button-wrapper>').append($cancelButton));                
        $tooltip.append($('<div class=tooltip-buttons-wrapper>').append($buttons));                

        var $arrow = $('<div class="tooltip-arrow">');
        $arrow.append($('<i class="fa fa-caret-left">'));

        _this.$stepHighlighterToolTip = $('<div id="' + _this.scenariosContainerId + '-step-highlighter-tooltip" class="step-highlighter-tooltip-wrapper">');
        _this.$stepHighlighterToolTip.append($tooltip);
        _this.$stepHighlighterToolTip.append($arrow);
        _this.$stepHighlighter.append(_this.$stepHighlighterToolTip);
    },

    buildStepHighlighterWizard: function buildStepHighlighterWizard() {
        var _this = this;

        _this.$stepHighlighterWizard = $('<div id="' + _this.scenariosContainerId + '-step-highlighter-wizard" class="step-highlighter-wizard-wrapper">');
        _this.$stepHighlighterWizard.append($('<div class="step-highlighter-wizard">').append('<img src="/img/wizard.png">'));
        _this.$stepHighlighterWizard.css({ 'z-index': _this.stepHighlighterZIndex });

        $('body').append(_this.$stepHighlighterWizard);
    },

    scrollElemToViewScreen: function scrollElemToViewScreen($elem, callBack) {
        var _this = this;

        var scrollList = [];

        var pageWidth = $('body').outerWidth();
        var pageHeight = $('body').outerHeight();

        //if(elem.offset().top < 0 || (elem.offset().top + elem.height()) > (pageHeight - 10)) {
            var parentList = [];
            var $parent = $elem.parent();
            do {                
                if ($parent.hasClass('has-scroll') && $parent[0].scrollHeight > $parent.outerHeight()) {
                    parentList.push($parent);
                }

                $parent = $parent.parent();
            } while ($parent.length);                

            parentList.reverse();

            for (var i = 0; i < parentList.length; i++) {
                $parent = parentList[i];
                var $nextElem = $elem;
                if (i !== (parentList.length - 1)) {
                    $nextElem = parentList[i + 1];
                }

                if ($parent[0].scrollHeight > $parent.outerHeight()) {
                    var padding = parseInt($parent.css('padding-top').replace('px', ''));
                    var scroll  = 0;

                    var parentPos = getPosition($parent[0]);
                    var elemPos = getPosition($elem[0]);
                    scroll = elemPos.y - parentPos.y - padding;

                    if (scroll) {  
                        scrollList.push({ elem: $parent, scroll: scroll });
                    }
                } 
            }

        //}

        _this.doScollElemToViewScreen(scrollList, callBack);
    },

    doScollElemToViewScreen: function doScollElemToViewScreen(scrollList, callBack) {
        var _this = this;

        if (scrollList.length) {
            var scrollElem = scrollList.pop();
            scrollElem.elem.animate({ scrollTop: scrollElem.scroll - 40 }, 'fast', function () {
                _this.doScollElemToViewScreen(scrollList, callBack);
            });
        } else {
            callBack();
        }
    },

    showStepHighlighterOverElem: function showStepHighlighterOverElem($elem, autoHide, animateMove, callBack) {
        var _this = this;

        var css = _this.countHighlighter($elem);                
        if (_this.$stepHighlighter.is(':visible') && animateMove) {
            _this.$stepHighlighter.animate(css, 'slow', function () {
                if (callBack) {
                    callBack();
                }
            });
        } else {
            if (_this.$stepHighlighter.is(':visible')) {
                _this.$stepHighlighter.fadeOut('slow', function () {
                    _this.$stepHighlighter.css(css).fadeIn('slow', function () {
                        if (callBack) {
                            callBack();
                        }
                    });
                });    
            } else {
                _this.$stepHighlighter.css(css).fadeIn('slow', function () {
                    if (callBack) {
                        callBack();
                    }
                });
            }
        }

        _this.$stepHighlighter.data('elem', $elem);

        _this.$stepHighlighter.removeClass('auto-hide');
        if (autoHide) {
            _this.$stepHighlighter.addClass('auto-hide');
        }

        _this.$stepHighlighterWizard.css({ top: (_this.stepHighlighterPosition.y1 - _this.stepHighlighterPadding - 74) + 'px', left: (_this.stepHighlighterPosition.x1 - _this.stepHighlighterPadding - 52) + 'px' });
    },

    countHighlighter: function countHighlighter($elem) {
        var _this = this;

        var x = $elem.offset().left;
        var y = $elem.offset().top;
        var width = $elem.outerWidth();
        var height = $elem.outerHeight();

        if ((y + height) > ($('body').height() - 10)) {
            height -= ((y + height) - ($('body').height() - 10));
        }

        var css = { top: (y - _this.stepHighlighterPadding) + 'px', left: (x - _this.stepHighlighterPadding) + 'px', width: (width  + 2 * _this.stepHighlighterPadding) + 'px', height: (height + 2 * _this.stepHighlighterPadding) + 'px' };
        _this.stepHighlighterPosition = { x1: x, y1: y, x2: x + width, y2: y + height };
        return css;
    },

    recountHighlighter: function recountHighlighter() {
        var _this = this;

        var $elem = _this.$stepHighlighter.data('elem');
        _this.$stepHighlighter.css(_this.countHighlighter($elem));
    },

    hideStepHighlighter: function hideStepHighlighter() {
        var _this = this;

        if(_this.$stepHighlighter.is(':visible')) {
            _this.$stepHighlighter.fadeOut('slow');
            _this.removePageDocAnchor();
            _this.closePageDoc();
        }                       

        $('body').removeClass('run-page-intro');
    },

    updateStepHighlighterToolTip: function updateStepHighlighterToolTip($scenario, actualStep, $elem, preferPosition) {
        var _this = this;

        if ($scenario.data('hide_controls')) {
            _this.$stepHighlighterToolTip.addClass('hide-controls');
        } else {
            _this.$stepHighlighterToolTip.removeClass('hide-controls');
        }        

        _this.$stepHighlighterToolTip.show();

        var $step = _this.getScenarioStep($scenario, actualStep);
        _this.$stepHighlighterToolTip.find('.tooltip-header').html($scenario.data('scenario_title'));
        _this.$stepHighlighterToolTip.find('.tooltip-title').html($step.find('.title').html());
        _this.$stepHighlighterToolTip.find('.tooltip-desc').html($step.find('.description').html());

        var $progressBar = _this.$stepHighlighterToolTip.find('.tooltip-progress-bar');
        $progressBar.empty();
        var $steps = _this.getScenarioSteps($scenario);
        var findActualStep   = false;
        var actualStepNumber = 0;
        $steps.each(function () {
            var $step = $(this);
            var $bull = $('<a href="#" class="go-to-step ' + (actualStep === $step.data('step') ? 'actual' : '') + '" title="' + $step.find('.title').text() + '" data-step="' + $step.data('step') + '">');
            $progressBar.append($bull);

            if (!findActualStep) {
                actualStepNumber++;
            }

            if (actualStep === $step.data('step')) {
                findActualStep = true;
            }
        });

        var counter = _this.$stepHighlighterToolTip.find('.tooltip-counter');
        counter.find('.act-step-number').text(actualStepNumber);
        counter.find('.total-step-number').text($steps.length);

        _this.$stepHighlighterToolTip.find('.tooltip-buttons').find('.prev-step').removeClass('disabled');
        _this.$stepHighlighterToolTip.find('.tooltip-buttons').find('.next-step').removeClass('disabled');
        if (isEmpty(_this.getPrevScenarioStep($scenario, actualStep)) && isEmpty($scenario.data('prev_scenario'))) {
            _this.$stepHighlighterToolTip.find('.tooltip-buttons').find('.prev-step').addClass('disabled');    
        }

        _this.removeNextButtonHightlight();
        if (isEmpty(_this.getNextScenarioStep($scenario, actualStep)) && isEmpty($scenario.data('next_scenario'))) {
            _this.$stepHighlighterToolTip.find('.tooltip-buttons').find('.next-step').addClass('disabled');    
        } else if (isEmpty(_this.getNextScenarioStep($scenario, actualStep)) && !isEmpty($scenario.data('next_scenario'))) {
            _this.addNextButtonHightlight();
        }

        var lastPosition = _this.$stepHighlighterToolTip.data('position');
        var position = _this.updateStepHighlighterToolTipPosition($elem, preferPosition);                                
        var width = !isEmpty($step.data('width')) ? $step.data('width') : _this.stepHighlighterToolTipWidth;
        var zIndex = !isEmpty($step.data('z_index')) ? $step.data('z_index') : _this.stepHighlighterZIndex;

        width = width > ($(window).width() - 100) ? $(window).width() - 100 : width;

        _this.$stepHighlighter.css({ 'z-index': zIndex });
        _this.$stepHighlighterToolTip.removeClass(lastPosition);
        _this.$stepHighlighterToolTip.addClass(position);
        _this.$stepHighlighterToolTip.data('position', position);
        _this.$stepHighlighterToolTip.find('.step-highlighter-tooltip').css({ width: width + 'px' });
    },

    updateStepHighlighterToolTipPosition: function updateStepHighlighterToolTipPosition($elem, position) {
        var _this = this;

        _this.$stepHighlighterToolTip.find('.step-highlighter-tooltip-wrapper').css('top', '');
        _this.$stepHighlighterToolTip.find('.step-highlighter-tooltip').css('top', '');

        if(isEmpty(position) || position === 'auto') {
            position = _this.getPositionStepHighlighterToolTip($elem);
        }

        var arrowIcon = '';
        switch (position) {
            case 'left' : arrowIcon = 'fa fa-caret-right'; break;
            case 'right' : arrowIcon = 'fa fa-caret-left'; break;
            case 'top' : arrowIcon = 'fa fa-caret-down'; break;
            case 'bottom' : arrowIcon = 'fa fa-caret-up'; break;
        }

        _this.$stepHighlighterToolTip.find('.tooltip-arrow').find('i').replaceWith($('<i class="' + arrowIcon + '">'));
        if (position === 'right' || position === 'left') {                    
            var offset = _this.getTopOffsetStepHighlighterToolTip($elem);
            if (offset) {        
                _this.$stepHighlighterToolTip.find('.step-highlighter-tooltip-wrapper').css({ top: offset + 'px' });
                _this.$stepHighlighterToolTip.find('.step-highlighter-tooltip').css({ top: offset + 'px' });        
            }
        }

        return position;
    },

    getTopOffsetStepHighlighterToolTip: function getTopOffsetStepHighlighterToolTip($elem) {
        var _this = this;

        var pageWidth  = $('body').outerWidth();
        var pageHeight = $('body').outerHeight();

        if($('.page-doc-wrapper').is(':visible')) {
            pageWidth -= $('.page-doc-wrapper').width();
        }

        var x = $elem.offset().left;
        var y = $elem.offset().top;
        var width  = $elem.outerWidth();
        var height = $elem.outerHeight();

        var stepHighlighterToolTipWidth  = _this.$stepHighlighterToolTip.find('.step-highlighter-tooltip').outerWidth() + 20;
        var stepHighlighterToolTipHeight = _this.$stepHighlighterToolTip.find('.step-highlighter-tooltip').outerHeight() + 20;
        var offset = 0;

        if ((y + stepHighlighterToolTipHeight) > pageHeight) {
            offset = (y + stepHighlighterToolTipHeight) - pageHeight;
            if (offset > y) {
                offset = y;
            }

            offset = -1 * offset;
        }

        return offset;
    },

    getPositionStepHighlighterToolTip: function getPositionStepHighlighterToolTip($elem) {
        var _this = this;

        var pageWidth  = $('body').outerWidth();
        var pageHeight = $('body').outerHeight();

        if ($('.page-doc-wrapper').is(':visible') && $(window).width() > 1299) {
            pageWidth -= $('.page-doc-wrapper').width();
        }

        var x = $elem.offset().left;
        var y = $elem.offset().top;
        var width = $elem.outerWidth();
        var height = $elem.outerHeight();

        var stepHighlighterToolTipWidth  = _this.$stepHighlighterToolTip.find('.step-highlighter-tooltip').outerWidth() + 20;
        var stepHighlighterToolTipHeight = _this.$stepHighlighterToolTip.find('.step-highlighter-tooltip').outerHeight() + 20;

        if ((pageWidth - (x + width)) > stepHighlighterToolTipWidth) {
            return 'right';
        }

        if (x > stepHighlighterToolTipWidth) {
            return 'left';
        }

        if ((pageHeight - (y + height)) > stepHighlighterToolTipHeight) {
            return 'bottom';
        }

        if (y > stepHighlighterToolTipHeight) {
            return 'top';
        }

        return 'innter-br';
    },

    //------------------------------------------------------------------

    buildScenarioPicker: function buildScenarioPicker() {
        var _this = this;

        _this.$scenarioPicker = $('<div id="' + _this.scenariosContainerId + '-scenario-picker" class="scenario-picker-wrapper">');
        _this.$scenarioPicker.append($('<div class="scenario-picker">'));
        _this.$scenarioPicker.css({ 'z-index': _this.scenarioPickerZIndex });

        $('body').append(_this.$scenarioPicker);
    },

    clearScenarioPicker: function clearScenarioPicker() {
        var _this = this;

        _this.$scenarioPicker.find('.scenario-picker').empty();
    },

    addScenarioIntoPicker: function addScenarioIntoPicker(scenarioID) {
        var _this = this;

        var $scenario = _this.$scenarios.find('#' + scenarioID);
        var $scenarioHtml = $('<div class="scenario run-intro" data-scenario="' + scenarioID + '">');
        $scenarioHtml.append($('<div class="scenario-title">').append($scenario.data('scenario_title')));

        if ($scenario.data('scenario_desc')) {
            $scenarioHtml.append($('<div class="scenario-desc">').append($scenario.data('scenario_desc')));
        }

        _this.$scenarioPicker.find('.scenario-picker').append($scenarioHtml);
    },

    viewScenarioPicker: function viewScenarioPicker(x, y) {
        var _this = this;

        _this.$scenarioPicker.css({ top: y + 'px', left: x + 'px' }).fadeIn('slow');
    },

    hideScenarioPicker: function hideScenarioPicker() {
        var _this = this;

        _this.$scenarioPicker.fadeOut('slow');
        _this.removeNextButtonHightlight();
    },

    //------------------------------------------------------------------

    autoStartIntro: function autoStartIntro(scenarioID, fromStep, data) {
        var _this = this;

        if (_this.$stepHighlighter.is(':animated')) {
            _this.$stepHighlighter.finish();
        }

        _this.hideScenarioPicker();   

        var scenario = _this.$scenarios.find('#' + scenarioID);
        if (scenario.length) {
            var action  = scenario.data('action');
            if(!isEmpty(action)) {
                if(!window[action](fromStep)) {
                    setTimeout(function () {
                        _this.autoStartIntro(scenarioID, fromStep);
                    }, 500);
                    return;
                }
            }

            _this.actualScenarioID = scenarioID;                
            _this.$actualScenario = _this.$scenarios.find('#' + _this.actualScenarioID);                
            _this.actualScenarioStep = fromStep ? fromStep : _this.getNextScenarioStep(_this.$actualScenario);
            _this.actualScenarioStepElem = null;

            if(!isEmpty(_this.actualScenarioStep)) {
                var state = _this.viewScenarioStep(_this.$actualScenario, _this.actualScenarioStep);

                if (state > 0) {
                    if (!_this.$actualScenario.data('without_doc')) {
                        _this.openPageDoc();
                    }

                    $('body').addClass('run-page-intro');
                }
            } else {
                _this.cancelIntro();
            }

            setDBCookie(_this.actualScenarioID, 1, false);
        } else {
            _this.loadScenario(scenarioID, function () {
                _this.autoStartIntro(scenarioID, fromStep);
            }, data);
        }                    
    },

    openPageDoc: function openPageDoc() {
        var _this = this;

        return; //nove neotevirame dokumentaci automaticky
        /*
        if($(window).width() > 900) {
            if(_this.pageDoc) _this.pageDoc.openPageDoc();
        }
        */
    },

    closePageDoc: function closePageDoc() {
        var _this = this;

        return; //nove neotevirame dokumentaci automaticky
        /*
        if(_this.pageDoc) _this.pageDoc.closePageDoc();
        */
    },

    removePageDocAnchor: function removePageDocAnchor() {
        var _this = this;

        if(_this.pageDoc) {
            _this.pageDoc.removeAnchor();
        }
    },

    highlightPageDoc: function highlightPageDoc(anchor) {
        var _this = this;

        if(_this.pageDoc && _this.pageDoc.opened) {
            _this.pageDoc.highlightParagraph(anchor);
            _this.pageDoc.setAnchor(anchor);
        }        
    },

    //------------------------------------------------------------------

    init: function init() {
        var _this = this;

        _this.cancelTitle = services.get('translator').trans('Quit');
        _this.prevStepTitle = services.get('translator').trans('Back');
        _this.nextStepTitle = services.get('translator').trans('Next');

        _this.$scenarios = $('#' + _this.scenariosContainerId);

        _this.buildScenarioPicker();
        _this.buildStepHighlighter();

        _this.pageDoc = services.get('page-doc');

        this.regCallBacks();
    }
});
